import Events from '../Widgets/Events/Events';
import './Dashboard.scss';
import DashboardCards from './DashboardCards/DashboardCards';
import DashboardHeader from './DashboardHeader/DashboardHeader';

export default function Dashboard() {
    return (
        <div className='Dashboard'>
            <div className='Dashboard__container'>
                <DashboardHeader />
                <div className='Dashboard__container-content'>
                    <Events />
                    <DashboardCards />
                </div>
            </div>
        </div>
    );
}
